// Generated by pnpm icons:generate. Edit native source assets and semantic roles, not this file.
import { createCoreLineIcon } from '../CoreLineIcon';
export const BackIcon = /*#__PURE__*/ createCoreLineIcon(
  'back',
  '0 0 14 14',
  '<g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10 0.5 3.85355 6.64645c-0.19526 0.19526 -0.19526 0.51184 0 0.7071L10 13.5" stroke-width="1"></path></g>',
);
